import { useTranslation } from '../contexts/TranslationContext';
import { ChevronDown } from './Icons';

export function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();
  const selectedFlag = language === 'fr' ? '🇫🇷' : '🇬🇧';
  const selectedLabel = language.toUpperCase();

  return (
    <div data-language-select className="group relative shrink-0">
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value as 'en' | 'fr')}
        aria-label={language === 'fr' ? 'Langue' : 'Language'}
        className="peer absolute inset-0 z-10 h-full w-full cursor-pointer appearance-none rounded-lg border-0 opacity-0"
      >
        <option value="fr">🇫🇷 FR</option>
        <option value="en">🇬🇧 EN</option>
      </select>
      <span
        data-language-value
        className="theme-control flex h-10 min-w-[5.5rem] items-center rounded-lg border-0 bg-[rgb(var(--theme-primary)/0.1)] px-3 text-sm font-black leading-none tracking-[0.08em] shadow-none transition-colors group-hover:bg-[rgb(var(--theme-primary)/0.16)] peer-focus-visible:shadow-[0_0_0_3px_rgb(var(--theme-primary)/0.28)]"
        aria-hidden="true"
      >
        <span className="flex items-center gap-1.5">
          <span>{selectedFlag}</span>
          <span>{selectedLabel}</span>
        </span>
        <ChevronDown className="ml-auto h-3.5 w-3.5 shrink-0 text-[rgb(var(--theme-muted))]" />
      </span>
    </div>
  );
}
